export default __webpack_public_path__ + "static/media/placeholder_dummy2016-friseur01-mobile-de.dc53b243.png";